// @flow

import React from 'react';
import glamorous from 'glamorous';
import Tappable from 'app/components/commons/Tappable';
import * as cssUtils from 'app/utils/cssUtils';
import { PlayChip } from 'app/components/styled/currencyIcons';

type Props = {
  cost?: number,
  disabled?: boolean,
  id: number,
  image: *,
  name: string,
  onClick: () => void,
  price: number,
};

const defaultProps = {
  cost: null,
  disabled: false,
};

const CostBox = glamorous.div(props => ({
  alignItems: 'center',
  backgroundColor: props.disabled ? props.theme.color.basis4 : props.theme.color.primary,
  borderRadius: '0 0 4px 4px',
  color: 'white',
  display: 'flex',
  fontSize: props.theme.fontSize.large,
  height: 50,
  justifyContent: 'center',
}));

const GiftContent = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flexGrow: 1,
});

const Price = glamorous.div(({ theme }) => ({
  height: 50,
  fontSize: theme.fontSize.medium,
  backgroundColor: theme.color.basis3,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: theme.fontWeight.demiBold,
  color: theme.color.white,
}));

const Inner = glamorous.div(props => ({
  color: props.theme.color.basis1,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 200,
  justifyContent: 'space-between',
  transition: 'background-color 0.2s',
  overflow: 'hidden',
  height: '100%',
  ...cssUtils.hover({
    backgroundColor: props.theme.color.basis6,
  }),
  [props.theme.mediaQuery.desktopAndUp]: {
    minHeight: 260,
  },
}));

const Name = glamorous.div(({ theme }) => ({
  fontSize: theme.fontSize.medium,
  fontWeight: theme.fontWeight.demiBold,
  margin: '0 auto',
  textAlign: 'center',
}));

const Outer = glamorous.div(({ theme }) => ({
  flexBasis: '50%',
  flexGrow: 0,
  flexShrink: 1,
  minWidth: 0,
  height: '100%',
  [theme.mediaQuery.desktopAndUp]: {
    flexBasis: '25%',
  },
}));

const Top = glamorous.div({
  padding: 10,
  flexGrow: 1,
});

function GiftItem({ disabled, cost, id, image, name, onClick, price }: Props) {
  return (
    <Tappable
      component={Outer}
      disabled={disabled}
      onTap={disabled ? undefined : () => onClick(id)}
    >
      <Inner>
        <GiftContent>
          <Top>
            <img
              alt={name}
              src={image.res1x}
              srcSet={`${image.res1x} 1x, ${image.res2x} 2x`}
              width="100%"
              height="auto"
            />
            <Name>{name}</Name>
          </Top>
          <Price>
            <div>
              <PlayChip />
              {price}
            </div>
          </Price>
        </GiftContent>
        {cost !== null && <CostBox disabled={disabled}>${cost}</CostBox>}
      </Inner>
    </Tappable>
  );
}

GiftItem.defaultProps = defaultProps;

export default GiftItem;
